module.exports = __webpack_public_path__ + "img/twenty_four_hours.52a1b2c2.svg";